import styled from 'styled-components';

export const PaymentReportingHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  background-color: #f5f6f7;
  padding: 24px;

  .header-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    order: 2;

    @media screen and (min-width: 769px) {
      order: -1;
    }
  }

  .header-badge {
    background-color: #d5f3f9;
    color: #03698c;
    padding: 8px;
    font-size: 14px;
    font-weight: 700;
  }

  .header-text {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    @media screen and (min-width: 769px) {
      align-items: center;
    }
  }

  .credit-score-image {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      max-width: 240px;
    }
  }

  @media screen and (min-width: 769px) {
    grid-template-columns: 2fr 1fr;
  }
`;

export const PaymentReportingForm = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;

  .date-picker {
    margin: 8px 0px;
  }

  .RadioGroup-item {
    padding: 5px 0;
  }

  .Radio-btn {
    margin-right: 8px;
  }

  .RadioGroup {
    margin-bottom: 24px;
  }
`;

export const FAQAccordionContainer = styled.aside`
  padding: 0px 16px;
  margin-bottom: 16px;
  margin-top: 24px;
  & > div {
    height: 100%;
  }

  .Row {
    margin: 0px;
    padding: 0px;
  }

  .cursorPointer {
    cursor: pointer;
  }

  .SpacerRow {
    padding-top: 24px;
  }

  @media screen and (min-width: 769px) {
    padding: 0px;
    margin-bottom: 0px;
  }
`;

export const ErrorScreen = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .Icon.warning.error-icon {
    color: #c88205;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContentBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media screen and (min-width: 769px) {
    grid-template-columns: 2fr 1fr;
  }
`;
